import {
  LocationOn as LocationOnIcon
} from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import {
  Box,
  Button,
  Chip,
  FormControl,
  MenuItem,
  Modal,
  Select,
  Typography
} from "@mui/material";
import DOMPurify from "dompurify";
import { marked } from "marked";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  applyJob,
  deleteJob,
  generateAISkills,
  generateJobDescription,
  getDocuments,
  getSingleJobDesc,
  getSinglePostedJob,
  postDocumentUpload,
  saveParticularJob,
  updateJob
} from "../../../../Redux/Reducers/JobReducer";
import { setDeeplinking } from "../../../../Redux/Reducers/OnboardingReducer";
import JobDescriptionSkeleton from "../../../LoadingSkeleton/JobDescriptionSkeleton";
import { useProfileContext } from "../../../ProfileDetailContext";
import { useQuantityContext } from "../../../QuantityContext";
import DocumentVerificationComponent from "../DocumentVerificationComponent";
import GlobalSearchCandidates from "../GlobalSearchCandidates";
import { DeleteLightBox } from "../ProfessionalProfile";
import ApplicantInterviewRounds from "./ApplicantInterviewRounds";
import ApplicantOfferLetter from "./ApplicantOfferLetter";
import ApplicationTrackerforApplicant from "./ApplicationTrackerforApplicant";
import OfferLetterDetails from "./OfferLetterDetails";
import PostingJobModal from "./PostingJobModal";
import RecommendedJobsCompo from "./RecommendedJobsCompo";

const SingleJobDescription = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const objectId = localStorage.getItem("objectId");
  const [loading, setLoading] = useState(false);
  const generatedSkills = useSelector((state) => state?.jobs?.generatedSkills);
  const postedJob = useSelector((state) => state?.jobs?.singleJobDescription);
  const singlePostedJob = postedJob?.job;
  const [localGeneratedSkills, setLocalGeneratedSkills] = useState(generatedSkills);
  const [isPostingModalOpen, setIsPostingModalOpen] = useState(false);
  const [selectedChips, setSelectedChips] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);
  const [hiringInputValue, setHiringInputValue] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isLoadingDescription, setIsLoadingDescription] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [editingJob, setEditingJob] = useState(null);
  const [showStatusConfirmation, setShowStatusConfirmation] = useState(false);
  const [selectedNewStatus, setSelectedNewStatus] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const { openSnackbar } = useQuantityContext();
  const { ExperienceList } = useProfileContext();
  const companyLogo = ExperienceList[0]?.companylogo?.data || "";
  const [saving, setSaving] = useState(false);
  const [hiringModalOpen, setHiringModalOpen] = useState(false);
  const [isLoadingSkills, setIsLoadingSkills] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [jobStatus, setJobStatus] = useState(singlePostedJob?.status || "Open");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [currentJobType, setCurrentJobType] = useState(singlePostedJob?.type || "OPEN");

  // Update job type when singlePostedJob change
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState("auto");
  const Resumedata = useSelector((state) => state?.ProfileArray?.ResumeData?.data) || [];
  const hasResume = Resumedata?.some((item) => item?.document_url);

  const offerLetters = useSelector((state) => state?.jobs?.OfferLetters) || []
  // console.log("offerLetters123", offerLetters);
  // Video Resume
  const rawVideoUrlArray = useSelector(
    (state) => state?.ProfileArray?.videoResume
  );
  const videoUrlArray = Array.isArray(rawVideoUrlArray) ? rawVideoUrlArray : [];
  const hasVideoResume = videoUrlArray?.some((item) => item?.document_url);
  const shouldRenderSidebar = (singlePostedJob && singlePostedJob?.status) || singlePostedJob?.job_status;
  const requestedDocumentsData = useSelector((state) => state.jobs?.documentsData)
  const requestedDocuments = requestedDocumentsData?.uploaded_docs
  const [hiringData, setHiringData] = useState({
    role: "",
    company_name: "",
    company_url: "",
    company_location: "",
    about_company: "",
    dept_type: "",
    emp_type: "",
    edu_level: "",
    experience: "",
    salary: "",
    location: "",
    mode: "",
    skills: [],
    job_summary: "",
    responsibility: [],
    qualifications: [],
    perks: [],
    pre_requisites: [],
    no_of_rounds: "",
    no_of_open_positions: "",
  });

  // console.log("singlePostedJobNNN", singlePostedJob)
  // console.log("requestedDocumentsMMMMMM", requestedDocuments)
  // console.log("location.pathname", location.pathname)
  const handleSuccess = (message, severity = "success", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };

  const handleFailure = (message, severity = "error", autoClose = 6000) => {
    openSnackbar(message, severity, autoClose);
  };
  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  useEffect(() => {
    const fetchJobDesc = async () => {
      if (!id) return;

      setLoading(true);
      try {
        await dispatch(getSingleJobDesc(id));
        await dispatch(getDocuments(singlePostedJob?.id))
      } catch (error) {
        console.error("Error fetching job description:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobDesc();
  }, [id, dispatch]);


  useEffect(() => {
    if (singlePostedJob?.type) {
      setCurrentJobType(singlePostedJob.type);
    }
  }, [singlePostedJob]);

  useEffect(() => {
    if (!contentRef.current || !singlePostedJob?.job_description_md) return;

    const element = contentRef.current;

    const updateHeight = () => {
      const height = element.scrollHeight;
      // Only update if we have a valid height
      if (height > 0) {
        setContentHeight(`${height}px`);
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(height.toString());
        }
      } else {
        // Retry after a short delay if height is 0
        setTimeout(updateHeight, 100);
      }
    };

    // Initial update with delay to ensure content is rendered
    const timer = setTimeout(updateHeight, 300);

    // Observer for dynamic content changes
    const observer = new MutationObserver(updateHeight);
    observer.observe(element, { childList: true, subtree: true, characterData: true });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [singlePostedJob?.job_description_md]);



  const parseSkillsArray = (data) => {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    try {
      const parsedData = JSON.parse(data);
      return Array.isArray(parsedData)
        ? parsedData
        : data?.split(", ").map((item) => item.trim());
    } catch (error) {
      return data?.split(",").map((item) => item.trim());
    }
  };

  const renderPostedDate = (date) => {
    const postedDate = new Date(date);
    const now = new Date();
    const diffInMs = now - postedDate;

    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInDays / 365);

    if (diffInMinutes < 1) {
      return "just now";
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes}m ${diffInMinutes === 1 ? "" : ""} ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours}h ${diffInHours === 1 ? "" : ""} ago`;
    } else if (diffInDays === 1) {
      return "1d ago";
    } else if (diffInDays < 30) {
      return `${diffInDays}d ago`;
    } else if (diffInMonths < 12) {
      return `${diffInMonths}m ${diffInMonths === 1 ? "" : ""} ago`;
    } else {
      return `${diffInYears}y ${diffInYears === 1 ? "" : ""} ago`;
    }
  };

  const createResponsibilityListItems = (data) => {
    if (!data)
      return <Typography variant="body1">No data available.</Typography>;

    let parsedData;

    if (typeof data === "string") {
      try {
        // Try to parse it as JSON array
        parsedData = JSON.parse(data);
      } catch (error) {
        // If parsing fails, treat it as a plain string
        parsedData = [data];
      }
    } else if (Array.isArray(data)) {
      parsedData = data;
    } else {
      // Handle edge case (non-array object)
      return <Typography variant="body1">Invalid data format.</Typography>;
    }

    if (!Array.isArray(parsedData) || parsedData?.length === 0) {
      return <Typography variant="body1">No data available.</Typography>;
    }

    return parsedData?.map((line, index) => (
      <Box key={index} display="flex" alignItems="center" gap={1}>
        <Typography variant="body1">•</Typography>
        <Typography variant="body1">{line}</Typography>
      </Box>
    ));
  };

  const handleHiringInputChange = (e) => {
    // e.preventDefault();
    const { name, value } = e.target;
    // console.log("handleHiring", name, value);

    if (name === "responsibility" || name === "qualifications") {
      setHiringData((prev) => ({ ...prev, [name]: value.split("\n") }));
    } else if (name === "job_description_md") {
      setHiringData((prev) => ({ ...prev, job_description_md: value }));
    } else {
      setHiringData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const formatSalary = (salary) => {
    if (!salary) return "Not Specified";

    // Remove all spaces and convert to string
    const cleanSalary = String(salary).replace(/\s/g, "");

    const formatToLakhsAndThousands = (amount) => {
      if (amount >= 100000) {
        const lakhs = (amount / 100000).toFixed(1);
        return `${lakhs}L`;
      } else if (amount >= 1000) {
        const thousands = (amount / 1000).toFixed(1);
        return `${thousands}K`;
      }
      return `${amount.toLocaleString()}`;
    };

    // Handle monthly salary format (e.g. "20,000" or "40,000")
    if (/^₹?\d{1,2},\d{3}$/.test(cleanSalary.replace("₹", ""))) {
      const amount = parseInt(cleanSalary.replace(/[^\d]/g, ""));
      return `${formatToLakhsAndThousands(amount)} per month`;
    }

    // Handle "k" format (e.g. "20k-40K")
    if (/^\d+k-\d+k$/i.test(cleanSalary.toLowerCase())) {
      const [min, max] = cleanSalary.toLowerCase().split("-");
      const minValue = parseInt(min.replace("k", "")) * 1000;
      const maxValue = parseInt(max.replace("k", "")) * 1000;
      return `${formatToLakhsAndThousands(
        minValue
      )} - ${formatToLakhsAndThousands(maxValue)}`;
    }

    // Handle salary with rupee symbol and commas (annual format)
    if (cleanSalary.includes("₹")) {
      const numbers = cleanSalary.match(/[\d,]+/g);
      if (numbers && numbers?.length === 2) {
        const min = parseInt(numbers[0].replace(/,/g, ""));
        const max = parseInt(numbers[1].replace(/,/g, ""));
        return `${formatToLakhsAndThousands(min)} - ${formatToLakhsAndThousands(
          max
        )}`;
      }
    }

    // Handle plain number ranges with commas
    if (cleanSalary.includes("-")) {
      const [min, max] = cleanSalary
        .split("-")
        .map((num) => parseInt(num.replace(/[^\d]/g, "")));
      if (!isNaN(min) && !isNaN(max)) {
        // If numbers are in thousands range, assume monthly
        if (min < 100000 && max < 100000) {
          return `${formatToLakhsAndThousands(
            min
          )} - ${formatToLakhsAndThousands(max)}`;
        }
        return `${formatToLakhsAndThousands(min)} - ${formatToLakhsAndThousands(
          max
        )}`;
      }
    }

    // Handle single number
    const singleNumber = parseInt(cleanSalary.replace(/[^\d]/g, ""));
    if (!isNaN(singleNumber)) {
      // If number is in thousands range, assume monthly
      if (singleNumber < 100000) {
        return `${formatToLakhsAndThousands(singleNumber)}`;
      }
      return `${formatToLakhsAndThousands(singleNumber)}`;
    }

    return "Not Specified";
  };

  const handleStatusClose = () => {
    setAnchorEl(null);
  };

  const handleEditJobClick = (job, e) => {
    e.preventDefault();
    e.stopPropagation();

    // Transform job data to match hiring data format
    const transformedData = {
      ...job,
      skills: parseSkillsArray(job?.skills),
      responsibility: Array.isArray(job?.responsibility)
        ? job?.responsibility
        : job?.responsibility?.split("\n").filter(Boolean),
      qualifications: Array.isArray(job.qualifications)
        ? job?.qualifications
        : job?.qualifications?.split("\n").filter(Boolean),
      perks: Array.isArray(job.perks) ? job.perks : [],
      pre_requisites: Array.isArray(job?.pre_requisites)
        ? job?.pre_requisites
        : [],
    };

    setHiringData(transformedData);
    setLocalGeneratedSkills(parseSkillsArray(job?.skills));
    setSelectedChips(parseSkillsArray(job?.skills));
    setCurrentStep(1);
    setHiringModalOpen(true);
  };

  const handleJobDelete = (jobId) => {
    // const userConfirmed = window.confirm("Are you sure you want to delete this job?");
    // if (userConfirmed) {
    //    deleteJob(jobId);
    // }
    setJobToDelete(jobId);
    setShowDeleteModal(true);
  };

  const cleanNestedJSON = (data) => {
    if (!data) return [];
    try {
      // If it's already an array, return it
      if (Array.isArray(data)) return data;

      // If it's a string, try to parse it
      let parsed = data;
      while (typeof parsed === "string") {
        try {
          parsed = JSON.parse(parsed);
        } catch {
          // If parsing fails, split by newlines or commas
          return parsed
            ?.split(/[\n,]/)
            .map((item) =>
              item
                .trim()
                .replace(/\\"/g, '"')
                .replace(/\\/g, "")
                .replace(/^\[|\]$/g, "")
                .replace(/^"|"$/g, "")
            )
            .filter(Boolean);
        }
      }
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (error) {
      return typeof data === "string" ? [data] : [];
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await dispatch(deleteJob(jobToDelete));

      if (response?.payload?.statusCode === 200) {
        // setJobs((prev) => {
        //   if (!Array.isArray(prev)) {
        //     prev = []; // Convert to an array if prev is an object
        //   }
        //   return prev.filter(job => job?.id !== jobToDelete);
        // });

        openSnackbar("Job deleted successfully", "success");
        navigate(`/alljobs`);
      }
    } catch (error) {
      openSnackbar("Failed to delete job", "error");
    }

    setShowDeleteModal(false);
    setJobToDelete(null);
  };

  const menuOptions = {
    "Department Type": [
      "Human Resources (HR)",
      "Finance & Accounting",
      "Marketing",
      "Sales",
      "Customer Support",
      "Operations",
      "Legal & Compliance",
      "Administrative",
      "Information Technology (IT)",
      "Software Development",
      "Data & Analytics",
      "Product Management",
      "Medical & Clinical",
      "Pharmacy",
      "Research & Development (R&D)",
      "Production & Manufacturing",
      "Engineering",
      "Quality Assurance (QA)",
      "Academic Affairs",
      "Student Affairs",
      "Training & Development",
      "Public Relations (PR)",
      "Procurement & Purchasing",
      "Supply Chain & Logistics",
    ],
    "Employment Type": [
      "Full-time/ Permanent",
      "Part-time",
      "Freelance",
      "Internship",
      "Trainee",
    ],
    "Education Type": [
      "Undergraduate",
      "10th/SSLC/SCC",
      "12th/PUC/HSC",
      "Postgraduate",
      "Higher Education",
      "Any Graduate",
    ],
    "Experience Range": [
      "0-1 year",
      "1-2 years",
      "2-4 years",
      "4-6 years",
      "6-8 years",
      "8-10 years",
      "10-15 years",
      "15-20 years",
      "20+ years",
    ],
    "Salary Range": [
      "Less than 2,00,000",
      "2,00,000-5,00,000",
      "5,00,000-10,00,000",
      "10,00,000-15,00,000",
      "15,00,000-20,00,000",
      "20,00,000-30,00,000",
      "35,00,000-50,00,000",
      "50,00,000-1,00,00,000",
      "Above-1,00,00,000",
    ],
    "Work Location": ["Bangalore", "Hyderabad", "Chennai", "Delhi", "Kochi"],
    "Work Mode": ["On-site", "Hybrid", "Remote"],
  };

  const handleEditClick = (targetStep) => {
    setCurrentStep(targetStep);
  };

  const handleHiringAddChip = (newChip) => {
    if (
      newChip &&
      !localGeneratedSkills.includes(newChip) &&
      newChip.trim() !== ""
    ) {
      // Add to local skills
      setLocalGeneratedSkills((prev) => [...prev, newChip]);
      // Select the chip immediately
      setSelectedChips((prev) => [...prev, newChip]);
      // Update hiringData.skills
      setHiringData((prev) => ({
        ...prev,
        skills: [...(prev.skills || []), newChip],
      }));
      setHiringInputValue("");
    }
  };

  const handleChipToggle = (chip) => {
    setSelectedChips((prev) =>
      prev.includes(chip) ? prev.filter((c) => c !== chip) : [...prev, chip]
    );
  };

  const handleHiringChipDelete = (chip) => {
    setLocalGeneratedSkills((prev) => prev.filter((item) => item !== chip));
    setSelectedChips((prev) => prev.filter((item) => item !== chip));
    setEditingJob((prev) => ({
      ...prev,
      skills:
        typeof prev?.skills === "string"
          ? prev.skills
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s !== chip)
            .join(", ")
          : Array.isArray(prev?.skills)
            ? prev.skills.filter((skill) => skill !== chip)
            : [],
    }));
  };

  const handleEditSkillClick = async () => {
    try {
      const jobData = {
        role: editingJob?.role,
        dept_type: editingJob?.dept_type,
        experience: editingJob?.experience,
      };

      const response = await dispatch(generateAISkills(jobData));

      if (response?.statusCode == 200) {
        const generatedSkills = response?.data?.skills || [];
        setLocalGeneratedSkills(generatedSkills);

        // Automatically select the generated skills
        setSelectedChips(generatedSkills);
        setEditingJob((prev) => ({
          ...prev,
          skills: generatedSkills,
        }));

        openSnackbar("Skills generated successfully", "success");
      }
    } catch (error) {
      openSnackbar("Failed to generate skills", "error");
      console.error("Error generating skills:", error);
    }
  };

  const handleStatusClick = (event) => {
    setAnchorEl(event.currentTarget);
    setShowSelect(!showSelect);
  };

  const handleEditResponseClick = async () => {
    try {
      const jobData = {
        role: editingJob?.role,
        company_name: editingJob?.company_name,
        dept_type: editingJob?.dept_type,
        experience: editingJob?.experience,
      };

      const response = await dispatch(generateJobDescription(jobData));

      if (response?.statusCode === 200) {
        const generatedContent = response.data;

        setEditingJob((prev) => ({
          ...prev,
          job_summary: generatedContent?.job_summary || prev?.job_summary,
          responsibility:
            generatedContent?.responsibility || prev?.responsibility,
          qualifications:
            generatedContent?.qualifications || prev?.qualifications,
          about_company: generatedContent?.about_company || prev?.about_company,
        }));

        openSnackbar("Job description generated successfully", "success");
      }
    } catch (error) {
      openSnackbar("Failed to generate job description", "error");
    }
  };

  const handleBack = () => {
    setCurrentStep((prev) => prev - 1);
  };

  const handleNext = async () => {
    try {
      if (currentStep === 1) {
        // setIsLoadingSkills(true);
        const jobData = {
          role: hiringData?.role,
          dept_type: hiringData?.dept_type,
          experience: hiringData?.experience,
        };
        await dispatch(generateAISkills(jobData));
      }

      if (currentStep === 2) {
        setIsLoadingDescription(true);
        const jobData = {
          role: hiringData?.role,
          company_name: hiringData?.company_name,
          dept_type: hiringData?.dept_type,
          experience: hiringData?.experience,
        };

        const response = await dispatch(generateJobDescription(jobData));

        if (response?.payload?.statusCode === 200) {
          const generatedContent = response?.payload?.data;
          setHiringData((prev) => ({
            ...prev,
            job_summary: generatedContent?.job_summary || prev?.job_summary,
            responsibility: Array.isArray(generatedContent?.responsibilities)
              ? generatedContent?.responsibilities
              : cleanNestedJSON(generatedContent?.responsibility),
            qualifications: Array.isArray(generatedContent?.qualifications)
              ? generatedContent?.qualifications
              : cleanNestedJSON(generatedContent?.qualifications),
            about_company:
              generatedContent?.about_company || prev?.about_company,
          }));
        }
      }
      setCurrentStep((prev) => prev + 1);
    } catch (error) {
      console.error("Error:", error);
      openSnackbar("Failed to generate content", "error");
    } finally {
      // setIsLoadingSkills(false);
      setIsLoadingDescription(false);
    }
  };

  const saveJob = async () => {
    // if (!!hiringData?.id) return;

    try {
      setSaving(true);
      // Wait for job update to complete
      const response = await dispatch(updateJob(editingJob));

      if (response?.payload?.statusCode === 200) {
        const updatedJob = response?.payload?.data?.job;
        dispatch(getSinglePostedJob(singlePostedJob?.id));
        // setJobs((prev) => {
        //   console.log("prev", prev);
        //   if (!Array.isArray(prev)) {
        //     prev = []; // Convert to an array if prev is an object
        //   }
        //   return prev.map((job) =>
        //     job?.id === updatedJob?.id
        //       ? { ...updatedJob, logo: job?.logo } // Preserve existing logo
        //       : job
        //   );
        // });
      }

      setEditingJob(null);

      // Fetch updated job list only after successful update
      // await dispatch(getAllJobs());
      setCurrentStep(1);
      setIsPostingModalOpen(false);
      //   setRefreshJobs((prev) => !prev);

      // openSnackbar("Job updated successfully", "success")
    } catch (error) {
      // console.error("Failed to update job:", error);
      openSnackbar("Failed to update job", "error");
    } finally {
      setSaving(false);
    }
  };

  const handleHiringSubmit = async () => {
    try {
      setSaving(true);

      // Format the data for submission
      const formattedHiringData = {
        id: hiringData.id,
        data: {
          ...hiringData,
          skills: JSON.stringify(selectedChips),
          responsibility: JSON.stringify(
            Array.isArray(hiringData.responsibility)
              ? hiringData.responsibility
              : []
          ),
          qualifications: JSON.stringify(
            Array.isArray(hiringData.qualifications)
              ? hiringData.qualifications
              : []
          ),
          perks: JSON.stringify(
            Array.isArray(hiringData.perks) ? hiringData.perks : []
          ),
          pre_requisites: JSON.stringify(
            Array.isArray(hiringData.pre_requisites)
              ? hiringData.pre_requisites
              : []
          ),
          no_of_rounds: Number(hiringData.no_of_rounds),
          no_of_open_positions: Number(hiringData.no_of_open_positions),
        },
      };

      // console.log("formattedHiringData", formattedHiringData.data);

      let response;

      response = await dispatch(updateJob(formattedHiringData.data));

      if (
        response?.payload?.statusCode === 200 ||
        response?.payload?.statusCode === 201
      ) {
        openSnackbar(
          hiringData?.id
            ? "Job updated successfully!"
            : "Job created successfully!",
          "success"
        );

        // Reset states
        setHiringData({
          role: "",
          company_name: "",
          company_url: "",
          dept_type: "",
          emp_type: "",
          edu_level: "",
          experience: "",
          salary: "",
          location: "",
          mode: "",
          skills: [],
          candidate_profile: "",
          job_summary: "",
          qualifications: [],
          responsibility: [],
          about_company: "",
          company_location: "",
          perks: [],
          pre_requisites: [],
          no_of_rounds: "",
          no_of_open_positions: "",
        });
        setSelectedChips([]);
        setLocalGeneratedSkills([]);
        setCurrentStep(1);
        setHiringModalOpen(false);

        // Refresh job listings
        await dispatch(getSinglePostedJob(singlePostedJob?.id));
      }
    } catch (error) {
      console.error("Error submitting job:", error);
      openSnackbar("Failed to save job", "error");
    } finally {
      setSaving(false);
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%",   // mobile
      sm: "70%",   // tablet
      md: "600px", // desktop
    },
    maxWidth: "90vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const handleStatusChange = async (newStatus) => {
    try {
      // Prepare payload for status update
      const payload = {
        id: singlePostedJob?.id,
        status: newStatus,
      };

      // Dispatch updateJob action
      const result = await dispatch(updateJob(payload)).unwrap();

      if (result?.statusCode === 200) {
        // Update local state
        // setsingleJob((prev) => ({
        //   ...prev,
        //   status: newStatus,
        // }));

        // Update job status
        setJobStatus(newStatus);
        dispatch(getSingleJobDesc(singlePostedJob?.id));

        // Show success message
        openSnackbar("Job status updated successfully", "success");
      }

      // Close popover
      setShowSelect(false);
      handleStatusClose();
    } catch (error) {
      console.error("Failed to update job status:", error);
      openSnackbar("Failed to update job status", "error");
    }
  };

  // const handleApplyInitiation = (jobId) => {
  //   console.log("i am from single job page", hasVideoResume)
  //   if (!objectId) {
  //     openSnackbar("Please Login to Apply", "info");
  //     navigate("/login");
  //     return;
  //   }
  //   setSelectedJob(jobId);

  //   if (!hasResume) {
  //     setShowResumeModal(true);
  //   } else if (!hasVideoResume) {
  //     setShowVideoModal(true);
  //   } else {
  //     setShowConfirmationModal(true);
  //   }
  // };


  const handleApplyInitiation = (jobId, e) => {

    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // console.log("i am from single job page", hasVideoResume);
    // console.log("hasResume:", hasResume);

    if (!objectId) {
      const jobUrl = `/job-description/${jobId}`;
      dispatch(setDeeplinking(jobUrl));
      openSnackbar("Please Login or signup to Apply", "info");
      navigate("/jd-signup");
      return;
    }

    setSelectedJob(jobId);

    // Check for resume first
    if (!hasResume) {
      // console.log("No resume found, showing resume modal");
      setShowResumeModal(true);
      return; // Important: return here to stop further execution
    }

    // Then check for video resume
    if (!hasVideoResume) {
      // console.log("No video resume found, showing video modal");
      setShowVideoModal(true);
      return; // Important: return here to stop further execution
    }

    // Only show confirmation modal if both resume and video resume exist
    // console.log("Both resume and video resume exist, showing confirmation modal");
    setShowConfirmationModal(true);
  };


  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prev) => ({
      ...prev,
      ...newConfig,
    }));
  };

  const handleJobShare = (job) => {
    // setSelectedJob(job);
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/job-description/${job.id}`,
      showQr: false,
      profileType: "Job",
      handleSuccess,
      handleFailure,
    });
  };

  const handleJobSave = useCallback(
    (jobId) => {
      dispatch(saveParticularJob(jobId))
        .unwrap()
        .then(() => {
          openSnackbar("Job saved successfully!", "success");
          dispatch(getSingleJobDesc(singlePostedJob?.id)); // Refresh jobs list to update UI
        })
        .catch((error) => {
          openSnackbar("Failed to save job", "error");
        });
    },
    [dispatch]
  );

  // function getSideBar() {
  //   if (
  //     singlePostedJob?.application_status == "Interview In-Progress" ||
  //     singlePostedJob?.application_status == "Selected"
  //   ) {
  //     return <ApplicantInterviewRounds candidateId={singlePostedJob.id} />;
  //   } else if (singlePostedJob?.application_status?.includes("Offer")) {
  //     return (
  //       <Box
  //         sx={{ height: "78vh", overflowX: "scroll", scrollbarWidth: "none", padding: "0px" }}
  //       >
  //         <OfferLetterDetails />
  //         <ApplicantOfferLetter />
  //       </Box>
  //     );
  //   } else {
  //     return (
  //       <Box
  //         sx={{ height: "85vh", overflowX: "scroll", scrollbarWidth: "none" }}
  //       >
  //         <RecommendedJobsCompo />
  //       </Box>
  //     );
  //   }
  // }

  // const handleDocumentUploadSubmit = async (payload) => {
  //   console.log("Received from DocumentVerificationComponent:", payload);

  //   try {
  //     // Prepare FormData for file upload
  //     const formData = new FormData();

  //     payload.forEach((doc, index) => {
  //       formData.append(`documents[${index}][file_name]`, doc.name);
  //       formData.append(`documents[${index}][file]`, doc.file);
  //       formData.append(`documents[${index}][is_mandatory]`, doc.isMandatory || false);
  //       formData.append(`documents[${index}][category]`, doc.category || "Personal");
  //       formData.append(`documents[${index}][remarks]`, doc.subtitle || "");
  //     });

  //     // Add application_id
  //     formData.append('application_id', singlePostedJob?.id);

  //     // Log FormData entries
  //     for (let [key, value] of formData.entries()) {
  //       console.log(`${key}:`, value);
  //     }

  //     // Call the API
  //     const response = await dispatch(postDocumentUpload(formData)).unwrap();

  //     if (response?.statusCode === 200 || response?.statusCode === 201) {
  //       toast.success("Documents uploaded successfully!");

  //       // Refresh documents list
  //       await dispatch(getDocuments(singlePostedJob?.id));
  //     } else {
  //       toast.error(response?.message || "Failed to upload documents");
  //     }

  //   } catch (error) {
  //     console.error("Error uploading documents:", error);
  //     toast.error(error?.message || "Failed to upload documents.");
  //   }
  // };


  const handleDocumentUploadSubmit = async (payload) => {
    console.log("Received from DocumentVerificationComponent:", payload);

    try {
      // Prepare FormData for file upload
      const formData = new FormData();

      // Add documents_meta as a JSON string
      const documentsMeta = payload.map((doc, index) => ({
        file_name: doc.name,
        file_type: doc.file?.type || 'application/octet-stream',
        category: doc.category || "Personal",
        remarks: doc.subtitle || "",
        is_mandatory: doc.isMandatory || false,
        field_key: `documents[${doc.fieldKey || doc.name.toLowerCase().replace(/ /g, '_')}]`,
        is_generated: false
      }));

      formData.append('documents_meta', JSON.stringify(documentsMeta));

      // Append each file with the correct field key
      payload.forEach((doc, index) => {
        const fieldKey = doc.fieldKey || doc.name.toLowerCase().replace(/ /g, '_');
        // Append file with the field key pattern expected by the API
        formData.append(`documents[${fieldKey}]`, doc.file);
      });

      // Log FormData entries for debugging
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}:`, value.name, value.size, value.type);
        } else {
          console.log(`${key}:`, value);
        }
      }

      // Call the API with the application ID
      const response = await dispatch(postDocumentUpload({
        id: singlePostedJob?.id, // Application ID
        data: formData
      })).unwrap();

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        toast.success("Documents uploaded successfully!");

        // Refresh documents list
        await dispatch(getDocuments(singlePostedJob?.id));
      } else {
        toast.error(response?.message || "Failed to upload documents");
      }

    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error(error?.message || "Failed to upload documents.");
    }
  };


  function getSideBar() {
    if (
      singlePostedJob?.application_status == "Interview In-Progress" ||
      singlePostedJob?.application_status == "Selected"
    ) {
      return <ApplicantInterviewRounds candidateId={singlePostedJob.id} />;
    } else if (singlePostedJob?.application_status?.includes("Offer")) {
      return (
        <Box
          sx={{ height: "78vh", overflowX: "scroll", scrollbarWidth: "none", padding: "0px" }}
        >
          <OfferLetterDetails />
          <ApplicantOfferLetter />
        </Box>
      );
    } else if (singlePostedJob?.application_status == "Document Verification") {
      return (
        <Box
          sx={{ height: "85vh", overflowX: "scroll", scrollbarWidth: "none" }}
        >
          {/* Add your Document Verification component here */}
          {/* <DocumentVerificationComponent /> */}
          <DocumentVerificationComponent
            requestedDocuments={requestedDocuments} // from your DocumentRequestSlider submit
            onSubmit={handleDocumentUploadSubmit}
          />
        </Box>
      );
    } else {
      return (
        <Box
          sx={{ height: "85vh", overflowX: "scroll", scrollbarWidth: "none" }}
        >
          <RecommendedJobsCompo />
        </Box>
      );
    }
  }

  function processJobDescription(content) {
    if (!content) return "No information available.";

    // Detect if it's HTML (contains any tag)
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(content);

    // Convert Markdown to HTML if not HTML
    let html = isHtml ? content : marked.parse(content);

    // List of headings to highlight
    const headings = [
      "Job Summary",
      "Responsibilities",
      "Qualifications",
      "Perks & Benefits",
      "Perks &amp; Benefits",
      "Pre-requisites",
      "About the Company",
    ];
    // console.log("singlePostedJob123", singlePostedJob?.job_description_md);
    // console.log("html123", html);
    // Wrap headings in a span for styling
    headings.forEach((heading) => {
      // Match heading text inside any tag (h1-h6, p, etc.)
      const regex = new RegExp(`(>\\s*)(${heading})(\\s*<)`, "gi");
      html = html.replace(regex, `$1<span class="job-heading">$2</span>$3`);
    });

    return DOMPurify.sanitize(html);
  }

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="left"
        alignItems="left"
        height="60vh"
        width="92vw"
      >
        <JobDescriptionSkeleton />
      </Box>
    );
  }



  const handleApplyClick = async () => {
    setShowConfirmationModal(false);

    try {
      const result = await dispatch(applyJob(selectedJob)).unwrap();

      if (result?.statusCode === 200 || result?.statusCode === 201) {
        openSnackbar("Successfully applied!", "success");

        // Refresh the job data - this should update the type to "APPLIED"
        await dispatch(getSingleJobDesc(id)); // Use the current job ID from params

        // Also update local state
        setCurrentJobType("APPLIED");
      }
    } catch (error) {
      console.error("Application failed:", error);
      openSnackbar("Application failed", "error");
    }
  };


  return (
    <Box
      className="Allcards_full_container"
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        padding: "20px",
      }}
    >
      <Box
        sx={{
          width: "70%",
          // maxHeight: "100vh",
          // overflowY: "auto",
          scrollbarWidth: "none",
        }}
      >
        <Box
          className="job-header"
          bgcolor="white"
          borderRadius={2}
          p={2}
          mb={2}
          display="flex"
          flexDirection="column"
          sx={{
            backgroundImage:
              "linear-gradient(90deg, rgba(2, 0, 36, 1) 0%, rgba(0, 0, 105, 1) 0%, rgba(0, 212, 255, 1) 100%)",
          }}
          color="white"
        >
          <Box
            display="flex"
            justifyContent="space-between"
            gap="30px"
            alignItems="center"
          // border='1px solid red'
          >
            {/* <Box sx={{display:"flex", alignItems: "center", gap:"5px", }}> */}
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <img
                width={"80px"}
                height={"80px"}
                src={
                  singlePostedJob?.company_logo ||
                  "https://www.shutterstock.com/image-vector/image-icon-trendy-flat-style-600nw-643080895.jpg"
                }
              />
              {/* <Typography variant="body2" color="textSecondary" sx={{ textAlign:"end", fontSize:"16px" }}>
                   {jobs?.company_name}
                </Typography> */}
              {/* </Box> */}
              {/* Job Title and Details */}

              <Box
                display="flex"
                flexDirection="column"
                alignItems="left"
                color="text.secondary"
              >
                <Typography variant="h5" ml={1} sx={{ color: "white" }}>
                  {singlePostedJob?.role}
                </Typography>
                <Typography variant="body2" ml={1} sx={{ color: "cyan" }}>
                  {singlePostedJob?.company_name}
                </Typography>
              </Box>
            </Box>
            {/* <Box sx={{display:"flex", mt:0}} >
              <IconButton
                          size="small"
                          aria-label="share"
                          onClick={() => handleJobShare(singlePostedJob)}
                          sx={{ fontSize: "16px" }}
                        >
                          {singlePostedJob?.status == "open" ? (
                            <ShareIcon fontSize="small" />
                          ) : (
                            ""
                          )}
                        </IconButton>
                        <IconButton
                          size="small"
                          aria-label="save"
                          sx={{ fontSize: "16px" }}
                          onClick={() => handleJobSave(singlePostedJob?.id)}
                        >
                          {singlePostedJob?.is_saved ? (
                            <BookmarkIcon fontSize="small" />
                          ) : (
                            <BookmarkBorderIcon fontSize="small" />
                          )}
                        </IconButton>
            </Box> */}
            {singlePostedJob?.type == "POSTED" ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {!showSelect ? (
                  <Box onClick={handleStatusClick} sx={{ cursor: "pointer" }}>
                    <Chip
                      label={
                        singlePostedJob?.status == "close"
                          ? "Closed"
                          : singlePostedJob?.status
                      }
                      color={
                        singlePostedJob?.status === "open" ? "success" : "error"
                      }
                      variant="outlined"
                    />
                  </Box>
                ) : (
                  <FormControl size="small">
                    <Select
                      value={singlePostedJob?.status || "open"}
                      onChange={(e) => {
                        setSelectedNewStatus(e.target.value);
                        setShowStatusConfirmation(true);
                        setShowSelect(false);
                      }}
                      onBlur={() => setShowSelect(false)}
                      displayEmpty
                      inputProps={{ "aria-label": "Job Status" }}
                      sx={{
                        height: "32px",
                        "& .MuiSelect-select": {
                          paddingY: "2px",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor:
                            singlePostedJob?.status === "open"
                              ? "success.main"
                              : "error.main",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor:
                            singlePostedJob?.status === "open"
                              ? "success.main"
                              : "error.main",
                        },
                      }}
                    >
                      <MenuItem value="open">open</MenuItem>
                      <MenuItem value="close">close</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </Box>
            ) : (
              ""
            )}
            {singlePostedJob?.type == "APPLIED" ? (
              <Box>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  //   mt={2}
                  sx={{ color: "white" }}
                >
                  {renderPostedDate(singlePostedJob?.date_posted)}
                  {/* | Openings: 1 | Applicants: 95 */}
                </Typography>
              </Box>
            ) : (
              ""
            )}

            {/* Apply Button */}
          </Box>
          <Box display="flex" alignItems="center" gap="8px" mt={1}>
            <LocationOnIcon sx={{ fontSize: 18, color: "white", mr: 0.5 }} />
            <Typography variant="body2" mr={2}>
              {singlePostedJob?.location}
            </Typography>
            <HomeRepairServiceIcon
              sx={{ fontSize: 18, color: "white", mr: 0.5 }}
            />
            <Typography variant="body2" mr={2}>
              {singlePostedJob?.experience}
            </Typography>

            <CurrencyRupeeIcon sx={{ fontSize: 18, color: "white", mr: 0.5 }} />
            <Typography variant="body2">
              {formatSalary(singlePostedJob?.salary)}
            </Typography>
          </Box>
          <hr />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {/* <Box > */}
            {singlePostedJob?.type === "APPLIED" && (
              <Box
                sx={{
                  width: "80%", // or adjust as needed
                  //   border: "1px solid red",
                  padding: 2
                }}
              >
                {/* <Typography variant="body2" sx={{ pb: 2 }}>
                  Track your Application
                </Typography> */}
                <ApplicationTrackerforApplicant
                  applicant={singlePostedJob}
                  textColor="white"
                />
              </Box>
            )}

            {singlePostedJob?.type == "POSTED" ||
              singlePostedJob?.type == "OPEN" ? (
              <Typography
                variant="body2"
                color="textSecondary"
                mt={2}
                sx={{ color: "cyan" }}
              >
                {renderPostedDate(singlePostedJob?.date_posted)}
                {/* | Openings: 1 | Applicants: 95 */}
              </Typography>
            ) : (
              ""
            )}
            {singlePostedJob?.type == "POSTED" ? (
              <Box
                sx={{
                  width: "15%",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  // onClick={(e) => {
                  //   e.stopPropagation(); // Prevent Link click
                  //   setEditingJob(jobs);
                  // }}
                  onClick={(e) => handleEditJobClick(singlePostedJob, e)}
                  size="small"
                  sx={{ width: "10%", marginRight: "10px" }}
                >
                  Edit
                </Button>
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent Link click
                    handleJobDelete(singlePostedJob?.id);
                  }}
                  size="small"
                  sx={{
                    width: "10%",
                    backgroundColor: "#eb4e3d",
                    marginLeft: "10px",
                  }}
                >
                  Delete
                </Button>
              </Box>
            ) : (
              ""
            )}
            {singlePostedJob?.type == "OPEN" ? (
              <Box
                sx={{
                  width: "15%",
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  mt: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="success"
                  // onClick={(e) => {
                  //   e.stopPropagation(); // Prevent Link click
                  //   setEditingJob(jobs);
                  // }}
                  onClick={(e) => handleApplyInitiation(singlePostedJob.id, e)}
                  size="small"
                  sx={{ width: "10%", marginRight: "10px" }}
                >
                  Apply
                </Button>
              </Box>
            ) : (
              ""
            )}
          </Box>
        </Box>

        {/* Job Description */}
        <Box
          className="job-description-content"
          bgcolor="white"
          borderRadius={2}
          p={3}
          mb={3}
        >
          <Typography style={{ fontSize: "16px", fontWeight: "bold" }}>
            Job Description
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Role:</strong> {singlePostedJob?.role}
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Department Type:</strong> {singlePostedJob?.dept_type}
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Employment Type:</strong> {singlePostedJob?.emp_type}
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Role Category:</strong> {singlePostedJob?.role}
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Education:</strong>
            {singlePostedJob?.edu_level}
          </Typography>
          <Typography variant="body2" sx={{ padding: "5px" }}>
            <strong>Mode:</strong> {singlePostedJob?.mode}
          </Typography>

          <Typography
            variant="body1"
            mb={1}
            sx={{ color: "black", fontSize: "16px" }}
          >
            <strong
              style={{ fontSize: "14px", color: "black", marginLeft: "5px" }}
            >
              Key Skills:
            </strong>{" "}
            {parseSkillsArray(singlePostedJob?.skills || "[]").map(
              (skill, index) => (
                <Chip
                  key={index}
                  label={skill}
                  size="small"
                  sx={{ marginLeft: "10px" }}
                />
              )
            )}
          </Typography>
        </Box>

        {/* About Company */}
        <Box
          className="job-description-content"
          bgcolor="white"
          borderRadius={2}
          p={3}
          mb={3}
        >
          {/* Render sanitized HTML */}
          {/* <Box
            dangerouslySetInnerHTML={{
              __html: processJobDescription(
                singlePostedJob?.job_description_md
              ),
            }}
            sx={{
              "& h1, & h2, & h3, & h4, & h5, & h6": {
                // fontWeight: 'bold',
                fontSize: "14px",
                mt: 2,
                mb: 1,
              },
              "& .job-heading": {
                fontWeight: "bold",
                fontSize: "16px",
                display: "inline-block",
                color: "#222",
              },

              "& ul": { pl: 2, mb: 1.5, fontSize: "14px" },
              "& li": { mb: 0.5, fontSize: "14px" },
              "& p": { fontSize: "14px", mb: 1 },
            }}
          /> */}
          <Box
            ref={contentRef}
            sx={{
              height: contentHeight,
              overflow: "hidden",
              "& h1, & h2, & h3, & h4, & h5, & h6": {
                fontSize: "14px",
                mt: 2,
                mb: 1,
              },
              "& .job-heading": {
                fontWeight: "bold",
                fontSize: "16px",
                display: "inline-block",
                color: "#222",
              },
              "& ul": { pl: 2, mb: 1.5, fontSize: "14px" },
              "& li": { mb: 0.5, fontSize: "14px" },
              "& p": { fontSize: "14px", mb: 1 },
            }}
            dangerouslySetInnerHTML={{
              __html: processJobDescription(singlePostedJob?.job_description_md),
            }}
          />

        </Box>

        {/* Company Location */}
        <Box
          sx={{
            width: "20%",
            display: "flex",
            flexDirection: "row",
            margin: "auto",
          }}
        >
          {singlePostedJob?.type == "POSTED" ? (
            <Box
              sx={{
                width: "15%",
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                // onClick={(e) => {
                //   e.stopPropagation(); // Prevent Link click
                //   setEditingJob(jobs);
                // }}
                onClick={(e) => handleEditJobClick(singlePostedJob, e)}
                size="small"
                sx={{ width: "10%", marginRight: "10px" }}
              >
                Edit
              </Button>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent Link click
                  handleJobDelete(singlePostedJob?.id);
                }}
                size="small"
                sx={{
                  width: "10%",
                  backgroundColor: "#eb4e3d",
                  marginLeft: "10px",
                }}
              >
                Delete
              </Button>
            </Box>
          ) : (
            ""
          )}
          {singlePostedJob?.type == "OPEN" ? (
            <Box
              sx={{
                width: "15%",
                display: "flex",
                justifyContent: "space-evenly",
              }}
            >
              <Button
                variant="contained"
                color="success"
                // onClick={(e) => {
                //   e.stopPropagation(); // Prevent Link click
                //   setEditingJob(jobs);
                // }}
                onClick={(e) => handleApplyInitiation(singlePostedJob?.id, e)}
                size="small"
                sx={{ width: "10%", marginRight: "10px" }}
              >
                Apply
              </Button>
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>

      <Box
        sx={{
          // position: "sticky",
          // top: "110px", // Distance from the top of the viewport
          alignSelf: "flex-start", // Ensures it stays at the start of the parent container
          width: "30%", // Set appropriate width for the JobOpenings component
          // zIndex: 1000, // Ensure it stays above other elements if necessary
          // maxHeight: "90vh", // Adjusted max heights
          overflowY: "auto", // Enables vertical scroll if content overflows
          scrollbarWidth: "none",
        }}
      >
        {singlePostedJob?.type == "POSTED" ? (
          <GlobalSearchCandidates />
        ) : shouldRenderSidebar ? (
          getSideBar()
        ) : null}
        {/* <PersonalCalender /> */}
        {/* <RecommendedJobs /> */}
      </Box>

      <PostingJobModal
        open={hiringModalOpen}
        onClose={() => setHiringModalOpen(false)}
        currentStep={currentStep}
        hiringData={hiringData}
        companyLogo={companyLogo}
        menuOptions={menuOptions}
        hiringInputValue={hiringInputValue}
        localGeneratedSkills={localGeneratedSkills}
        selectedChips={selectedChips}
        isLoadingSkills={isLoadingSkills}
        isLoadingDescription={isLoadingDescription}
        handleHiringModalClose={() => setHiringModalOpen(false)}
        handleHiringInputChange={handleHiringInputChange}
        // handleKeyDown={handleKeyDown}
        handleHiringAddChip={handleHiringAddChip}
        handleChipToggle={handleChipToggle}
        handleHiringChipDelete={handleHiringChipDelete}
        handleEditSkillClick={handleEditSkillClick}
        handleEditResponseClick={handleEditResponseClick}
        handleBack={handleBack}
        handleNext={handleNext}
        handleClose={() => setIsPostingModalOpen(false)}
        handleHiringSubmit={handleHiringSubmit}
        setHiringInputValue={setHiringInputValue}
        setCurrentStep={setCurrentStep}
        isEditing={!!hiringData?.id}
      />

      <Modal
        open={showStatusConfirmation}
        onClose={() => setShowStatusConfirmation(false)}
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Confirm Status Change
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to change the job status to "
            {selectedNewStatus}"?
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
            <Button
              variant="outlined"
              onClick={() => setShowStatusConfirmation(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={async () => {
                try {
                  await handleStatusChange(selectedNewStatus);
                } finally {
                  setShowStatusConfirmation(false);
                }
              }}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>

      {showDeleteModal && (
        <DeleteLightBox
          LightBoxCloseFunction={setShowDeleteModal}
          Title="Job"
          Label="Are you sure you want to delete this job?"
          DeleteFunction={handleConfirmDelete}
          clearFields={() => setJobToDelete(null)}
        />
      )}

      {/* Resume Required Modal */}
      <Modal
        open={showResumeModal}
        onClose={() => setShowResumeModal(false)}
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Resume Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Please generate your AI Resume to apply for this position.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={() =>
                navigate(
                  "/myprofile?mainTab=professional_profile&subTab=resume"
                )
              }
            >
              Generate AI Resume
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal open={showVideoModal} onClose={() => setShowVideoModal(false)}>
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Video Resume Required
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            A video resume is mandatory to apply for this position. Create
            your video resume to proceed with the application.
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              variant="contained"
              onClick={() =>
                navigate(
                  "/myprofile?mainTab=professional_profile&subTab=resume"
                )
              }
            >
              Create Video Resume
            </Button>
          </Box>
        </Box>
      </Modal>


      <Modal
        open={showConfirmationModal}
        onClose={() => setShowConfirmationModal(false)}
      >
        <Box sx={modalStyle}>
          <Typography variant="h6" gutterBottom>
            Confirm Application
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Are you sure you want to apply for this position?
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "right" }}>
            <Button
              variant="outlined"
              onClick={() => setShowConfirmationModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleApplyClick}
            >
              Confirm Apply
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default SingleJobDescription;
